var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 68,
    viewBox: "0 0 67 68",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8848 24.0488L26.8853 24.0492C27.3493 24.48 27.5785 25.0108 27.5785 25.6757C27.5785 26.3339 27.3527 26.8368 26.885 27.2722C26.4197 27.7041 25.8239 27.9325 25.0544 27.9325C24.2796 27.9325 23.6553 27.701 23.1932 27.2719C22.7263 26.8384 22.5 26.3169 22.5 25.6757C22.5 25.0298 22.7313 24.4807 23.1937 24.0487C23.6568 23.619 24.2619 23.3887 25.0544 23.3887C25.8425 23.3887 26.4204 23.6164 26.8848 24.0488ZM27.0998 31.1725V46.3887H22.9772V31.1725H27.0998Z",
    fill: "#303030",
    stroke: "#303030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2841 32.6127L44.2843 32.6129C45.2937 33.709 45.8262 35.2391 45.8262 37.2694V46.1021H41.9613V37.9272C41.9613 36.7733 41.6605 35.8056 40.9962 35.0955C40.334 34.3878 39.4481 34.049 38.3993 34.049C37.3513 34.049 36.4648 34.3858 35.8022 35.0958C35.138 35.8058 34.8373 36.7735 34.8373 37.9272V46.1021H30.9436V31.1268H34.8373V32.7455V34.3289L35.7466 33.0327C36.1893 32.4016 36.7896 31.8969 37.56 31.52C38.3228 31.1468 39.19 30.9556 40.1735 30.9556C41.9242 30.9556 43.2769 31.5177 44.2841 32.6127Z",
    fill: "#303030",
    stroke: "#303030"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 34.3887,
    r: 33,
    stroke: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialLinkedin);
export default __webpack_public_path__ + "static/media/social-linkedin.13474099616c9888564cfee20c3e48131b77b2482c0eb214b9aebc84482572cd.svg";
export { ForwardRef as ReactComponent };